class measurementSettingDetailSave {
//  debugger;
  MeasurementSettingsID_GUID: string;
  OrderDetailID_GUID: string;
  CustomerID_GUID: string;
  OrderID_GUID: string;
  ProductItemID_GUID: string;
  innerObj: string;

  measurementSettingDetailSave() {
  //  debugger;
    this.MeasurementSettingsID_GUID = "";
    this.OrderDetailID_GUID = "";
    this.CustomerID_GUID = "";
    this.OrderID_GUID = "-1";
    this.ProductItemID_GUID = "-1";
    this.innerObj = "-1";
  }
}

export default measurementSettingDetailSave;
